import { Form, Formik, FormikHelpers } from "formik";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { SimpleModal, ViewTextLibraryForm } from "src/app/components";
import { useThematicsOptions, useWritingTypeOptions } from "src/app/hooks";
import { ContentTransport } from "src/app/transports/content";
import { IActionsModal } from "src/app/types/actionsModal";
import { Content, UpsertContentDTO, UpsertContentDTOSchema } from "src/app/types/content";
import { apiToFormikErrors } from "src/app/utils/formHelpers";
import { TDocMetrics } from "src/app/utils/textCheckHandler/handleData";

const ViewTextLibraryFormContainer = (props: IActionsModal<Content>) => {
    const { handleClose = () => {}, entity, updateGridOnSave = () => {} } = props;
    const { formatMessage } = useIntl();
    const [loadingApi, setLoadingApi] = useState(false);
    const [docMetrics, setDocMetrics] = useState<TDocMetrics>();

    const { thematicsOptions, loading } = useThematicsOptions();
    const { writingTypeOptions } = useWritingTypeOptions();

    const handleSubmit = async (_values: UpsertContentDTO, formikHelpers: FormikHelpers<any>) => {
        setLoadingApi(true);
        const currentValues = {
            ..._values,
            wordCount: docMetrics?.numberOfWords,
        };

        try {
            const res = await ContentTransport.save(currentValues, _values.id);
            const newEntity = {
                ...entity,
                content: res,
            };

            await updateGridOnSave(newEntity, true);
            toast.success(formatMessage({ id: "common.notification.success" }));
            setLoadingApi(false);
            handleClose();
        } catch (error: any) {
            setLoadingApi(false);
            toast.error(formatMessage({ id: "common.notification.error" }));
            apiToFormikErrors(error?.response, formikHelpers);
        }
        setLoadingApi(false);
    };

    const createOrder = () => {};

    return (
        <Formik
            initialValues={ContentTransport.formTransformer(entity)}
            onSubmit={(values: object, formikHelpers: FormikHelpers<object>) =>
                handleSubmit(values as UpsertContentDTO, formikHelpers)
            }
            validationSchema={UpsertContentDTOSchema}
        >
            <Form id="viewTextForm">
                <SimpleModal
                    entityName={formatMessage({ id: "common.entity.viewText" })}
                    handleClose={handleClose}
                    loading={loading && loadingApi}
                    formId="viewTextForm"
                    showModal={true}
                    modalProps={{ fullscreen: true }}
                    FooterLeftComponent={
                        <Button onClick={createOrder}>
                            {formatMessage({ id: "common.action.createOrder" })}
                        </Button>
                    }
                >
                    <ViewTextLibraryForm
                        entity={entity}
                        docMetrics={docMetrics}
                        setDocMetrics={setDocMetrics}
                        thematicsOptions={thematicsOptions}
                        writingTypeOptions={writingTypeOptions}
                    />
                </SimpleModal>
            </Form>
        </Formik>
    );
};

export default ViewTextLibraryFormContainer;
